export enum HttpException {
  InternalServerException = 'InternalServerException',
  InvalidCredentialsException = 'InvalidCredentialsException',
  IncorrectPasswordException = 'IncorrectPasswordException',
  ValidationException = 'ValidationException',
  AlreadyExistUserEmailException = 'AlreadyExistUserEmailException',
  AlreadyExistRoleException = 'AlreadyExistRoleException',
  AlreadyExistBusinessCategoryException = 'AlreadyExistBusinessCategoryException',
  AlreadyExistIndustryCategoryException = 'AlreadyExistIndustryCategoryException',
  AlreadyExistTaskMainCategoryException = 'AlreadyExistTaskMainCategoryException',
  AlreadyExistProjectCodeException = 'AlreadyExistProjectCodeException',
  OverTimeRecordSumException = 'OverTimeRecordSumException',
  NotFoundUserException = 'NotFoundUserException',
  NotFoundRoleException = 'NotFoundRoleException',
  NotFoundBusinessCategoryException = 'NotFoundBusinessCategoryException',
  NotFoundIndustryCategoryException = 'NotFoundIndustryCategoryException',
  NotFoundTaskMainCategoryException = 'NotFoundTaskMainCategoryException',
  NotFoundTaskSubCategoryException = 'NotFoundTaskSubCategoryException',
  NotFoundCustomerException = 'NotFoundCustomerException',
  NotFoundProjectException = 'NotFoundProjectException',
  NotFoundProjectOrderRecordException = 'NotFoundProjectOrderRecordException',
  NotFoundProjectSaleRecordException = 'NotFoundProjectSaleRecordException',
  NotFoundTimeRecordException = 'NotFoundTimeRecordException',
  NotFoundTimeMemoException = 'NotFoundTimeMemoException',
  CannotAccessException = 'CannotAccessException',
  CannotUpdateTimeRecordException = 'CannotUpdateTimeRecordException',
  CannotDeleteTimeRecordException = 'CannotDeleteTimeRecordException',
  CannotUpdateTimeMemoException = 'CannotUpdateTimeMemoException',
  CannotDeleteTimeMemoException = 'CannotDeleteTimeMemoException',
}

export enum HttpErrorMessage {
  CannotAccess = '접근 권한이 없습니다.',
  InvalidCredentials = '인증에 실패하였습니다.',
}
